import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { NavigateFunction } from "react-router-dom";
import { ConstatPartial } from "../../../../types/constats";
import StatusBadges from "../../StatusBadges";
import DropdownOptionsConstat from "../components/DropdownOptionsConstat/DropdownOptionsConstat";

type Options = {
  navigate: NavigateFunction;
  onDelete: (id: number) => void;
};

export default function useTableConstats({ navigate, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<ConstatPartial> = [
      {
        title: "TITRE",
        dataIndex: "name",
        key: "name",
        align: "left",
        width: 300,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "AUDIT",
        dataIndex: ["audit", "title"],
        key: "audit",
        align: "center",
        width: 200,
      },
      {
        title: "AUTEUR",
        dataIndex: ["creator", "fullname"],
        key: "author",
        align: "center",
        width: 200,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DATE",
        dataIndex: "dateEvt",
        key: "dateEvt",
        align: "center",
        width: 100,
        render: (value) => dayjs(value).format("DD/MM/YYYY"),
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "LIEU",
        dataIndex: "localisation",
        key: "localisation",
        align: "center",
        width: 100,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "GRAVITÃ",
        dataIndex: ["gravity", "name"],
        key: "gravity",
        align: "center",
        width: 100,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "STATUT",
        dataIndex: "statut",
        key: "statut",
        align: "center",
        width: 100,
        render: (value) => <StatusBadges value={value} type="events" />,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        key: "options",
        dataIndex: "",
        align: "center",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsConstat
            itemId={item.id}
            goToDetails={(id) => navigate(`/constats/${id}`)}
            onModify={(id) => navigate(`/constats/${id}/edit`)}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [navigate, onDelete]);

  const onRowClick = useCallback(
    (record: ConstatPartial) => ({
      onClick: () => navigate(`/constats/${record.id}`),
    }),
    [navigate],
  );

  return { columns, onRowClick };
}
